export default "__VITE_ASSET__0a7df8e9__"